export const USER_LOGOUT = 'general/USER_LOGOUT';